export default __webpack_public_path__ + "static/media/gallery1.86d62eb2.jpg";